var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React, { useState } from 'react';
import { classNames } from '@shapeable/utils';
var cls = classNames('horizon-indicators');
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { useInViewEffect } from '../hooks/use-in-view-effect';
export var HorizonIndicatorsDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    height: 84px;\n    position: relative;\n\n  "], ["\n    height: 84px;\n    position: relative;\n\n  "])))
});
var LineStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    height: 0;\n    font-size: 0;\n    position: absolute;\n    top: 42px;\n    width: 100%;\n    left: 0;\n    border-bottom: 1px solid ", ";\n  "], ["\n    height: 0;\n    font-size: 0;\n    position: absolute;\n    top: 42px;\n    width: 100%;\n    left: 0;\n    border-bottom: 1px solid ", ";\n  "])), theme.COLOR('line-mid'))
});
var ArrowStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    border: solid ", ";\n    border-width: 0 1px 1px 0;\n    display: inline-block;\n    padding: 6px;\n    transform: rotate(-45deg);\n\n    position: absolute;\n    top: ", "px;\n    right: 1px;\n  "], ["\n    border: solid ", ";\n    border-width: 0 1px 1px 0;\n    display: inline-block;\n    padding: 6px;\n    transform: rotate(-45deg);\n\n    position: absolute;\n    top: ", "px;\n    right: 1px;\n  "])), theme.COLOR('line-mid'), 42 - 6)
});
var DotStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    border: 1px solid ", ";\n    color: ", ";\n    border-radius: 50%;\n    display: flex;\n    background: ", ";\n    align-items: center;\n    justify-content: center;\n    font-size: ", ";\n    font-weight: 300;\n    position: absolute;\n    transform: rotate(0);\n  "], ["\n    border: 1px solid ", ";\n    color: ", ";\n    border-radius: 50%;\n    display: flex;\n    background: ", ";\n    align-items: center;\n    justify-content: center;\n    font-size: ", ";\n    font-weight: 300;\n    position: absolute;\n    transform: rotate(0);\n  "])), theme.COLOR('line-mid'), theme.COLOR('line-mid'), theme.COLOR('bright'), theme.FONT_SIZE(28))
});
var SmallDotStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    ", ";\n    width: 44px;\n    height: 44px;\n    left: 0%;\n    top: ", "px;\n  "], ["\n    ", ";\n    width: 44px;\n    height: 44px;\n    left: 0%;\n    top: ", "px;\n  "])), DotStyles, (84 - 44) / 2)
});
var MediumDotStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    ", ";\n    width: 64px;\n    height: 64px;\n    left: 0;\n    top: ", "px;\n    transition: all 0.8s;\n    ", "\n  "], ["\n    ", ";\n    width: 64px;\n    height: 64px;\n    left: 0;\n    top: ", "px;\n    transition: all 0.8s;\n    ", "\n  "])), DotStyles, (84 - 64) / 2, function (_a) {
    var started = _a.started;
    return started && css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      transform: rotate(720deg);\n      left: calc(33% + ", ");\n    "], ["\n      transform: rotate(720deg);\n      left: calc(33% + ", ");\n    "])), theme.UNIT(2));
  })
});
var LargeDotStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    ", ";\n    width: 84px;\n    left: 0;\n    height: 84px;\n    transition: all 0.8s;\n\n    ", "\n\n  "], ["\n    ", ";\n    width: 84px;\n    left: 0;\n    height: 84px;\n    transition: all 0.8s;\n\n    ", "\n\n  "])), DotStyles, function (_a) {
    var started = _a.started;
    return started && css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n      left: calc(66.667% + ", ");\n      transform: rotate(720deg);\n    "], ["\n      left: calc(66.667% + ", ");\n      transform: rotate(720deg);\n    "])), theme.UNIT(2));
  })
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Line: styled.div.attrs(cls.attr('line'))(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), LineStyles),
  Arrow: styled.span.attrs(cls.attr('arrow'))(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), ArrowStyles),
  SmallDot: styled.span.attrs(cls.attr('small-dot'))(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), SmallDotStyles),
  MediumDot: styled.span.attrs(cls.attr('medium-dot'))(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), MediumDotStyles),
  LargeDot: styled.span.attrs(cls.attr('large-dot'))(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), LargeDotStyles)
};
export var HorizonIndicators = function (props) {
  var className = props.className;
  var _a = __read(useState(false), 2),
    started = _a[0],
    setStarted = _a[1];
  var ref = useInViewEffect(function () {
    setStarted(true);
  });
  return React.createElement(My.Container, {
    ref: ref,
    className: cls.name(className)
  }, React.createElement(My.Line, null), React.createElement(My.Arrow, null), React.createElement(My.SmallDot, {
    started: started
  }, "\u00D7"), React.createElement(My.MediumDot, {
    started: started
  }, "\u00D7"), React.createElement(My.LargeDot, {
    started: started
  }, "\u00D7"));
};
HorizonIndicators.defaultProps = HorizonIndicatorsDefaultProps;
HorizonIndicators.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15;